import type { InventoryQuotation } from './types'

const STORAGE_KEY = 'erp.inventory.sales-quotations.v1'

function safeParse(json: string | null): InventoryQuotation[] {
  if (!json) return []
  try {
    const parsed = JSON.parse(json)
    if (!Array.isArray(parsed)) return []
    return parsed as InventoryQuotation[]
  } catch {
    return []
  }
}

export function listQuotations(branchId: number | undefined): InventoryQuotation[] {
  const all = safeParse(window.localStorage.getItem(STORAGE_KEY))
  if (branchId == null || !Number.isFinite(branchId)) return all
  return all.filter((q) => q.branchId === branchId)
}

export function getQuotation(id: string): InventoryQuotation | undefined {
  return safeParse(window.localStorage.getItem(STORAGE_KEY)).find((q) => q.id === id)
}

export function upsertQuotation(doc: InventoryQuotation): void {
  const all = safeParse(window.localStorage.getItem(STORAGE_KEY))
  const idx = all.findIndex((q) => q.id === doc.id)
  const next = idx >= 0 ? all.map((q, i) => (i === idx ? doc : q)) : [doc, ...all]
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
}

export function cancelQuotation(id: string): void {
  const all = safeParse(window.localStorage.getItem(STORAGE_KEY))
  const next = all.map((q) => (q.id === id ? { ...q, status: 'cancelled' as const, updatedAt: new Date().toISOString() } : q))
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
}
